import React from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useCartStore, useWishlistStore, useCompareStore } from '../store';
import './ProductCard.css';

export default function ProductCard({ product }) {
  const addItem     = useCartStore(s => s.addItem);
  const toggle      = useWishlistStore(s => s.toggle);
  const isWished    = useWishlistStore(s => s.isInWishlist(product.id));
  const toggleCmp   = useCompareStore(s => s.toggle);
  const isCompared  = useCompareStore(s => s.isInCompare(product.id));

  const handleAddToCart = async (e) => {
    e.preventDefault();
    await addItem(product, 1);
    toast.success(`${product.name} added to cart!`);
  };

  const handleWishlist = async (e) => {
    e.preventDefault();
    const added = await toggle(product);
    toast(added ? `❤️ Added to wishlist` : `Removed from wishlist`);
  };

  const handleCompare = (e) => {
    e.preventDefault();
    const ok = toggleCmp(product);
    if (ok === false) { toast.error('Max 4 products to compare'); return; }
    toast(isCompared ? 'Removed from compare' : '⚖️ Added to compare');
  };

  const discount = product.salePrice
    ? Math.round((1 - product.salePrice / product.price) * 100)
    : 0;

  return (
    <div className="product-card">
      <Link to={`/shop/${product.slug}`} className="product-card__img-link">
        <img src={product.images?.[0] || 'https://placehold.co/300x300?text=Peptide'} alt={product.name} loading="lazy" />
        {product.badge && <span className={`product-card__badge badge-${getBadgeColor(product.badge)}`}>{product.badge}</span>}
        {discount > 0 && <span className="product-card__discount">-{discount}%</span>}
      </Link>

      <div className="product-card__body">
        <p className="product-card__category">{product.category}</p>
        <Link to={`/shop/${product.slug}`} className="product-card__name">{product.name}</Link>

        <div className="product-card__rating">
          <span className="stars">{'★'.repeat(Math.round(product.rating || 0))}{'☆'.repeat(5 - Math.round(product.rating || 0))}</span>
          <span className="product-card__reviews">({product.reviewCount || 0})</span>
        </div>

        <p className="product-card__purity">Purity: <strong>{product.purity || '≥99%'}</strong></p>

        <div className="product-card__price">
          {product.salePrice ? (
            <>
              <span className="product-card__sale">${product.salePrice.toFixed(2)}</span>
              <span className="product-card__original line-through text-gray">${product.price.toFixed(2)}</span>
            </>
          ) : (
            <span className="product-card__sale">${product.price.toFixed(2)}</span>
          )}
        </div>

        <button className="btn btn-primary btn-sm product-card__cta" onClick={handleAddToCart}>
          🛒 Add to Cart
        </button>

        <div className="product-card__actions">
          <button onClick={handleWishlist} title="Wishlist" className={isWished ? 'active' : ''}>
            {isWished ? '❤️' : '🤍'} Wishlist
          </button>
          <button onClick={handleCompare} title="Compare" className={isCompared ? 'active' : ''}>
            ⚖️ Compare
          </button>
        </div>
      </div>
    </div>
  );
}

function getBadgeColor(badge) {
  const map = { 'Best Seller': 'green', 'Sale': 'red', 'New': 'yellow', 'Popular': 'green', 'Bundle': 'gray' };
  return map[badge] || 'gray';
}
